<template>
  <v-list-item :ripple="false"         
  class="mb-2 mx-4 rounded-lg white">
  <v-list-item-avatar>
    <v-icon>mdi-comment-text-outline</v-icon>
  </v-list-item-avatar>
      {{ customerComment }}
</v-list-item>
</template>

<script>
export default {
	name: "CustomerCommentAsText",
	computed: {
		customerComment() {
			return this.$store.state.customerComment
		},
	}
}
</script>

<style scoped>

</style>
